module.exports = __webpack_public_path__ + "static/media/gryffindor.7dd66c53.png";